import { useContext, useMemo } from 'react'

import { ILocaleContext, IUseLocale, LocaleFallbackValue } from './types'

import LocaleContext from './Locale.Context'
import LocaleModule from './Module'

const useSurveyLocale: IUseLocale = () => {
  const localeContext = useContext<ILocaleContext>(LocaleContext)
  return useMemo<ReturnType<IUseLocale>>(() => {
    function t<ValueType = string>(...path: string[]): ValueType {
      return LocaleModule.t(localeContext.surveyLocaleID, path) as ValueType
    }
    function _t<ValueType = string>(fallbackValue: LocaleFallbackValue, ...path: string[]): ValueType {
      return LocaleModule.t(localeContext.surveyLocaleID, path, fallbackValue) as ValueType
    }
    return {
      t,
      _t,
      get localeID() {
        return localeContext.surveyLocaleID
      },
      get languageTag() {
        return localeContext.surveyLocaleID.replace('_', '-')
      },
      get localeOptions() {
        return LocaleModule.options(localeContext.surveyLocaleID)
      }
    }
  }, [localeContext.surveyLocaleID])
}

export default useSurveyLocale
